import React, { createContext, useReducer, useEffect } from 'react';
import UserService from '../components/services/user.service.js'; // --- 1. מייבאים את ה-Service ---
import { getCurrentUser } from '../utils/api.js';
import authReducer from './reducers/authReducer.js';
import {
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    REGISTER_SUCCESS,
    REGISTER_FAIL
} from './types.js';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const initialState = {
        token: localStorage.getItem('token'),
        isAuthenticated: null,
        user: null,
        loading: true,
        error: null
    };

    const [state, dispatch] = useReducer(authReducer, initialState);

    // Load user - פונקציה זו נשארת כרגע כפי שהיא
    const loadUser = async () => {
        if (localStorage.token) {
            try {
                const res = await getCurrentUser();
                dispatch({ type: USER_LOADED, payload: res.data });
            } catch (err) {
                dispatch({ type: AUTH_ERROR });
            }
        } else {
            dispatch({ type: AUTH_ERROR });
        }
    };

    useEffect(() => {
        loadUser();
    }, []);

    // Register user
    // --- 2. הפונקציה עכשיו קוראת ל-UserService.register ---
    const register = async (formData, language) => {
        try {
            // ה-formData מכיל { fullName, email, password }
            // הוספנו את פרמטר השפה
            const user = await UserService.register(formData.fullName, formData.email, formData.password, language);
            dispatch({
                type: REGISTER_SUCCESS,
                payload: { token: localStorage.getItem('token'), user }
            });
            loadUser(); // טוען מחדש את פרטי המשתמש המלאים מהשרת
        } catch (err) {
            dispatch({
                type: REGISTER_FAIL,
                payload: err.message
            });
        }
    };

    // Login user
    // --- 3. הפונקציה עכשיו קוראת ל-UserService.login ---
    const login = async formData => {
        try {
            const user = await UserService.login(formData.email, formData.password);
            dispatch({
                type: LOGIN_SUCCESS,
                payload: { token: localStorage.getItem('token'), user }
            });
            loadUser();
        } catch (err) {
            dispatch({
                type: LOGIN_FAIL,
                payload: err.message
            });
        }
    };

    // Logout
    // --- 4. הפונקציה עכשיו קוראת ל-UserService.logout ---
    const logout = () => {
        UserService.logout();
        dispatch({ type: LOGOUT });
    };

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                isAuthenticated: state.isAuthenticated,
                user: state.user,
                loading: state.loading,
                error: state.error,
                register,
                login,
                logout,
                loadUser // חשוב להוסיף את loadUser כאן אם קומפוננטות אחרות צריכות אותו
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};